import React from 'react';
import classnames from 'classnames';
import Button from '@/common/components/button/button.component';
import CloseIcon from '~/public/assets/images/svg/close-line.svg';
import Search from '~/public/assets/images/svg/search.svg';
import Input from './input.component';

interface SearchBoxProps {
  className?: string;
  onSearch: (query: string) => void;
  style?: React.CSSProperties;
  placeholder?: string;
  withButton?: boolean;
  closeHandler?: (value: boolean) => void;
}
function SearchBox({
  className,
  onSearch,
  style,
  placeholder = 'جستجو...',
  withButton = false,
  closeHandler = () => {},
}: SearchBoxProps) {
  const onChangeHandler = (value: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(value.currentTarget.value);
  };

  return (
    <div className="flex justify-between">
      <Input
        size="large"
        placeholder={placeholder}
        onChange={onChangeHandler}
        rootClassName={`search-input alignRight`}
        style={{ ...style }}
        className={classnames(
          'w-full flex-1 border-silver-300 text-black-default',
          className
        )}
        suffix={<Search className="h-5 w-5 text-black-300" />}
      />

      {withButton && (
        <Button
          className="flex-0 !border-1 mr-3 !h-10 !w-10 !border-solid border-silver-300 bg-silver-100 p-2  text-black-300"
          onClick={() => {
            closeHandler(false);
          }}
        >
          <CloseIcon className="h-5 w-5 text-black-100" />
        </Button>
      )}
    </div>
  );
}

export default SearchBox;
